// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const ThreadsIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'threads'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M17.7817 11.2432C17.754 8.02571 16.0096 6.08682 13.0633 6.08682C11.0967 6.08682 9.44274 6.97627 8.57402 8.39392L10.478 9.72132C10.9714 8.94306 11.6524 8.29669 12.9033 8.29669C14.314 8.29669 15.0436 9.08193 15.252 10.5412C14.571 10.437 13.89 10.3814 13.1882 10.3814C9.37997 10.3814 7.58713 12.1049 7.58713 14.3841C7.58713 16.6633 9.37997 18.0673 12.0208 18.0673C14.9187 18.0673 16.649 16.1146 17.3579 13.6961C18.0945 14.0297 18.6018 14.8079 18.6018 15.9755C18.6018 19.1028 14.9952 20.8053 11.9375 20.8053C7.42754 20.8053 4.48105 17.8449 4.48105 13.0293C4.48105 7.12929 8.37955 3.34895 13.6192 3.34895C17.1355 3.34895 18.8728 4.89173 20.0541 6.96252L22 5.60046C20.7142 2.91797 17.8443 1 13.5357 1C6.66979 1 2 5.87144 2 12.9388C2 19.4016 6.57256 23.1541 12.0208 23.1541C16.5238 23.1541 21.0757 20.5274 21.0757 16.0311C21.0757 13.6824 19.7276 12.1257 17.7817 11.2432ZM11.9373 15.7253C10.9437 15.7253 10.068 15.2527 10.068 14.3841C10.068 13.0151 11.7496 12.5983 13.3966 12.5983C14.0221 12.5983 14.6336 12.6399 15.1755 12.7581C14.7864 14.537 13.6327 15.7255 11.9371 15.7255L11.9373 15.7253Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
ThreadsIcon.displayName = 'ThreadsIcon'
export { ThreadsIcon }
